














































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import SzTypes from "../../data/SzTypes";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class EnDayAccount extends Vue {
    @Prop({ type: [Object, Array] })
    data!: Voucher.Voucher[];

    myData: any = this.data;
    totalAmount: number = +this.myData.journals[this.myData.accIndex - 1].pay + +this.myData.journals[this.myData.accIndex - 1].income;
    amountArr: string[] = [];
    szTypes: SzTypes[] = SzTypes.list

    mounted() {
        this.fitMoney();
    }

    @Watch("data")
    dataChange(val: Voucher.Voucher[]) {
        this.myData = val;
        this.totalAmount = +this.myData.journals[this.myData.accIndex - 1].pay + +this.myData.journals[this.myData.accIndex - 1].income;
        this.fitMoney();
    }

    // 中文大写
    dx(n: any) {
        var unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";
        n += "00";
        var p = n.indexOf(".");
        if (p >= 0)
            n = n.substring(0, p) + n.substr(p + 1, 2);
        unit = unit.substr(unit.length - n.length);
        for (var i = 0; i < n.length; i++)
            str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
        if (String(n).indexOf("-") == -1) {
            if (/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
                return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
            } else {
                if (n == "000") return "零元整"
                else {
                    return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
                }
            }
        } else {
            let newStr = str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整"),
                need = newStr.slice(1),
                show = "负".concat(need);
            return show;
        }
    }

    fitMoney() {
        this.amountArr = [];
        if (this.totalAmount != 0) {
            let arr = String(this.totalAmount).split("").reverse(), j, hasDot = arr.indexOf(".");
            if (arr.indexOf("-") != -1) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr.indexOf("-") > -1) {
                        arr.splice(i, 1)
                    }
                }
            }
            if (hasDot == -1) {
                j = 8;
                this.amountArr[9] = "0";
                this.amountArr[10] = "0";
            } else {
                j = 10;
                arr.splice(hasDot, 1);
                for (var i = 0; i < arr.length; i++) {
                    if (arr.indexOf("-") > -1) {
                        arr.splice(i, 1)
                    }
                }

            }
            for (var i = 0; i < arr.length; i++) {
                this.amountArr[j] = arr[i];
                j--;
            }
        } else {
            this.amountArr = []
        }
    };
}
